import { ITable } from "entities/TableStorage/sdk";

export const removeRowsAndColumnsFromTableData = ({
  indexesOfRowsToBeRemoved,
  indexesOfColumnsToBeRemoved,
  tableData,
}: {
  indexesOfRowsToBeRemoved: Array<number>;
  indexesOfColumnsToBeRemoved: Array<number>;
  tableData: ITable["rows"];
}) =>
  tableData
    .filter((_, index) => !indexesOfRowsToBeRemoved.includes(index - 1))
    .map((row) => ({
      ...row,
      cells: row.cells.filter(
        (_, index) => !indexesOfColumnsToBeRemoved.includes(index)
      ),
    }));
